import stripeWhite from '../images/stripe-white.svg';
import stripeBlue from '../images/stripe-blue.svg';
import { useThemeContext } from '../../shared/context/ThemeContext';

export const useStripeLogo = () => {
  const { isDark } = useThemeContext();
  return isDark ? stripeWhite : stripeBlue;
}